import palette from '../../utils/colorPalette';
import TranslateTypography from './TranslateTypography';
import styled, { keyframes } from 'styled-components';

const Button = ({
  label,
  svgIcon,
  onClick,
  mode,
  variant,
  style,
  disable,
  children,
  labelStyle,
  onMouseEnter,
  onMouseLeave,
}) => {
  // 프로퍼티 기본 값 설정
  const mergedProps = {
    background: !!mode ? palette.button[mode] : palette.button['default'],
    background_hover: !!mode
      ? palette.buttonHover[mode]
      : palette.buttonHover['default'],
    color: !!mode ? palette.buttonText[mode] : palette.buttonText['default'],
    variant: !!variant ? variant : 'content1',
  };

  // RIPPLE 기능 (물결치는 animation)
  const handleClick = (event) => {
    const ripple = document.createElement('span');
    ripple.className = 'ripple';
    const rect = event.target.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;
    ripple.style.cssText = `
      width: ${size}px;
      height: ${size}px;
      top: ${y}px;
      left: ${x}px;
    `;
    event.target.appendChild(ripple);
    onClick && onClick(event);
  };

  return (
    <StyledButton
      {...mergedProps}
      onMouseEnter={(event) => {
        onMouseEnter && onMouseEnter(event);
      }}
      onMouseLeave={(event) => {
        onMouseLeave && onMouseLeave(event);
      }}
      onClick={(event) => {
        handleClick(event);
        // !!onClick && onClick(event);
      }}
      style={!!style ? style : null}
      disabled={disable}
    >
      {/* variant 종류는 Typography 참고 */}
      {!!label && (
        <TranslateTypography
          variant={mergedProps.variant}
          style={!!labelStyle ? labelStyle : null}
        >
          {label}
        </TranslateTypography>
      )}
      {!!svgIcon && svgIcon}
    </StyledButton>
  );
};

export default Button;

// ---------------------- STYLE ----------------------

const rippleAnimation = keyframes`
  to {
    transform: scale(4);
    opacity: 0;
  }
`;

const StyledButton = styled.button`
  position: relative;
  overflow: hidden;
  transition: background 400ms;
  color: #fff;
  padding: 0.5rem 1rem;
  font-family: 'NotoSansKR-Regular';
  outline: 0;
  border: 0;
  border-radius: 0.3rem;
  // box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1); /* black with 30% opacity */
  cursor: pointer;
  width: auto;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  &:hover {
    background: ${(props) => props.background_hover};
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  display: flex;
  justify-content: center;
  align-items: center;
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ${rippleAnimation} 450ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }
`;
